import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';

import { CampaignContact, CampaignLinkResponse, CampaignTopStats } from '../models/campaign.model';
import { Search } from '../models/search.model';
import { BaseService } from './base.service';

export class CampaignService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	linkCampaignContacts(id: number, search: Search): Promise<CampaignLinkResponse> {
		return this.mapResponse<CampaignLinkResponse>(this.http.post(`/ws/campaign/${id}/link/all`, classToPlain(search)), CampaignLinkResponse);
	}

	linkCampaignOperators(id: number, search: Search): Promise<CampaignLinkResponse> {
		return this.mapResponse<CampaignLinkResponse>(this.http.post(`/ws/campaign/${id}/operator/link`, classToPlain(search)), CampaignLinkResponse);
	}

	statsCalls(oid: number, cid: number): Promise<CampaignTopStats[]> {
		return this.mapResponse<CampaignTopStats[]>(this.http.get(`/ws/campaigncall/stasts/operator/${oid}/campaign/${cid}`), CampaignTopStats);
	}

	getCampaignContactStats(cid: number): Promise<CampaignTopStats[]> {
		return this.mapResponse<CampaignTopStats[]>(this.http.get(`/ws/campaigncontact/stats/campaign/${cid}`), CampaignTopStats);
	}

	assignOperator(ids: number[], oid: number): Promise<CampaignContact[]> {
		return this.mapResponse<CampaignContact[]>(this.http.post(`/ws/campaigncontact/assign/operator/${oid}`, { ids }), CampaignContact);
	}

	unassignOperator(ids: number[]): Promise<CampaignContact[]> {
		return this.mapResponse<CampaignContact[]>(this.http.post('/ws/campaigncontact/unassign/operatortocontacts', { ids }), CampaignContact);
	}

	delete(ids: number[]): Promise<CampaignContact[]> {
		return this.mapResponse<CampaignContact[]>(this.http.post('/ws/campaigncontact/delete', { ids }), CampaignContact);
	}

	sendMail(cid: number): Promise<any> {
		return this.mapResponse(this.http.post(`/ws/campaigncontact/email/${cid}`, {}));
	}

	printContacts(campid: number) {
		return this.mapResponse(this.http.post('/ws/campaigncontact/print/contacts/campaign', { campid }, { responseType: 'blob' }));
	}
}